import React from 'react';
import '../../styles/tachyons.scss';

// Use the require syntax to get a .scss from the file system before compile.
// Regular imports won't work here.
// tslint:disable-next-line
const variables = require('../../styles/_variables.scss');
export { variables };

const Tachyons: React.FC<{}> = ({ children }) => <>{children}</>;
export default Tachyons;
